module.exports = __webpack_public_path__ + "media/gt_intro.b1b5419a.mp4";